import { Component } from 'react';
import PropTypes from 'prop-types';
import { createAds, hideAd, receiveAds, eagerLoadAds } from '@this/ads';
import { Bling as GPT, Events } from 'react-gpt';
import {
  withBreakpoint
} from '@trulia/txl';
import { isMobile, isTablet } from '../../utils/screenSizes';

import {
  getFormattedAdTargetings,
  getAdUnitPath,
  getThirdPartyNoAdActionAdUnitPath,
} from './homeDetailsAdsUtil';

const thirdPartyNoAdAction = (evt) => {
  const adUnitPath = getThirdPartyNoAdActionAdUnitPath(evt);
  if (adUnitPath) {
    hideAd(adUnitPath);
  }
};

class HomeDetailsAdsContent extends Component {
  static propTypes = {
    ads: PropTypes.shape({
      targetings: PropTypes.array.isRequired
    }).isRequired
  }

  constructor(props) {
    super(props);

    this.adsLoaded = false;
  }

  loadAds(adTargetings) {
    createAds({
      adUnitPath: getAdUnitPath(adTargetings, this.props.breakpoint),
      adTargetings: getFormattedAdTargetings(adTargetings),
    });
  }

  componentDidUpdate(prevProps) {
    const { ads, url } = this.props;
    if (prevProps.url !== url) {
      this.adsLoaded = false;
    }

    if (ads?.targetings && prevProps.ads !== ads && !this.adsLoaded) {
      this.adsLoaded = true;
      this.loadAds(ads?.targetings);
    }
  }

  componentDidMount() {
    window.addEventListener('message', thirdPartyNoAdAction);
    this.updateAdDisplay();
  }

  componentWillUnmount() {
    window.removeEventListener('message', thirdPartyNoAdAction);
  }

  updateAdDisplay() {
    GPT.on(Events.SLOT_RENDER_ENDED, (evt) => {
      const adSlot = evt.slot.getAdUnitPath().split('/').pop();

      if (!evt.isEmpty) {
        receiveAds(adSlot);
        eagerLoadAds(evt);
      } else {
        hideAd(adSlot);
      }
    });
  }

  render() {
    return null;
  }
}

export default withBreakpoint(HomeDetailsAdsContent);

